export default __webpack_public_path__ + "static/media/price-tag-black.0918266a.svg";